/** Total session length before warning (15 minutes). */
export const SESSION_TIMER_DURATION_MS = 15 * 60 * 1000;

/** Show "Extend Session" dialog when remaining time is at or below this (1 minute). */
export const SESSION_WARNING_THRESHOLD_MS = 1 * 60 * 1000;

/** Countdown tick interval in milliseconds (1 second). */
export const SESSION_TICK_MS = 1000;
